<!-- For screen readers only  -->
<div class="td-wb-vh">
  <label [for]="datePickerInputId"
         [innerText]="label()"></label>
</div>
<ng-content select="input[tdWbDatePicker]" />
<ng-template #picker>
  <td-wb-overlay class="td-wb-datepicker-overlay">
    <td-wb-date-picker-inner
      [parsedDate]="getParsed()"
      [attr.id]="uniqueId"
      [mode]="mode()"
      [minMode]="minMode()"
      [maxMode]="maxMode()"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [showWeeks]="showWeeks()"
      [format]="format"
      [formatDay]="formatDay"
      [formatMonth]="formatMonth"
      [formatYear]="formatYear"
      [formatDayHeader]="formatDayHeader"
      [formatDayTitle]="formatDayTitle"
      [formatMonthTitle]="formatMonthTitle"
      [startingDay]="startingDay"
      [yearRange]="yearRange"
      [displayDatesOfCurrentMontyOnly]="displayDatesOfCurrentMontyOnly()"
      [disabledDates]="disabledDateInput()"
      (selectionDone)="onDatePickerChange($event)">
      <td-wb-day-picker />
      <td-wb-month-picker />
      <td-wb-year-picker />
      <td-wb-dual-month-day-picker />
    </td-wb-date-picker-inner>
  </td-wb-overlay>
</ng-template>
